/**
 * [INPUT]: 依赖 polar context 的 Pie variant 注册能力
 * [OUTPUT]: 对外提供 Pie 声明组件
 * [POS]: PieChart 的填充策略契约，无 DOM 输出，由 PieCanvas 消费
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
"use client";
import { useEffect } from "react"
import { usePolarPart } from "./polar-context"

/**
 * The pie/donut ring. Slices come from the chart `data` (one per row); this part
 * sets the shared fill variant. The dithered wedges are painted on the canvas.
 */
export function Pie({
  variant = "gradient"
}) {
  const ctx = usePolarPart("Pie", "pie")
  const { registerVariant, unregisterVariant } = ctx

  useEffect(() => {
    registerVariant("*", variant)
    return () => unregisterVariant("*");
  }, [variant, registerVariant, unregisterVariant])

  return null
}
